import React from 'react';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroImg2 from '../components/HeroImg2';
import Educ from '../components/Educ';
import Skill from '../components/skill'

const Education = () => {
    return (
        <div>
            <Navbar />
            <HeroImg2 />
            <Educ />
            <Skill />
            <Footer />

        </div>
    )
}

export default Education